<script lang="ts">import { onMount } from 'svelte';
import DesktopNav from './DesktopNav/DesktopNav.svelte';
import MobileNav from './MobileNav/MobileNav.svelte';
import Waypoint from '../shared/Waypoint/Waypoint.svelte';
import { ComponentType, DESKTOP_BREAKPOINT_CTA_SUBNAV } from '../../../js-v2/constants';
import { mobileCtaSubnavMenuStateStore } from '../../../js-v2/stores/mobile-cta-subnav-stores';
const STICKY_HTML_CLASS = 'pwn-has-sticky-cta-subnav';
const { id = '', title = '', navItems = [], primaryCtaButton = undefined, secondaryCtaButton = undefined, onlyShowCtaWhenSticky = false, showCtaOnCtaPage = false, disableStickyBehavior = false, hiddenUntilScrolled = false, reverseDesktopCtaButtons = false, disableIconCtaOnMobile = false, } = $props();
let documentEl = $state(undefined);
let isPastWaypoint = $state(false);
let innerWidth = $state(undefined);
const desktopMode = $derived(innerWidth === undefined ? null : innerWidth >= DESKTOP_BREAKPOINT_CTA_SUBNAV);
const isSticky = $derived(isPastWaypoint && !disableStickyBehavior);
$effect(() => {
    documentEl?.classList.toggle(STICKY_HTML_CLASS, !disableStickyBehavior);
});
// Close mobile nav when switching from mobile to desktop
$effect(() => {
    if (desktopMode && $mobileCtaSubnavMenuStateStore.isOpen) {
        mobileCtaSubnavMenuStateStore.toggle();
    }
});
onMount(() => {
    documentEl = document.documentElement;
});
</script>

<svelte:window bind:innerWidth />

<div
  class="CtaSubnav"
  data-cta-subnav-v2
  data-component-type={ComponentType.SUBNAVIGATION}
  data-nav-device-type={desktopMode ? 'Desktop' : 'Mobile'}
>
  <!--
    When the user scrolls past the waypoint, the nav becomes "sticky":
    - The nav element's CSS position switches from relative to fixed
    - The nav element is therefore removed from the document layout
    - A "shim" element is inserted into the layout, replacing the vertical
      space that the nav element used to take up in the layout, to prevent
      the page content from shifting upwards and being covered by the nav
    - The shim height is bound to the height of the nav element height.
  -->
  <Waypoint bind:isPast={isPastWaypoint} {hiddenUntilScrolled} />
  <DesktopNav
    {id}
    {title}
    {navItems}
    {primaryCtaButton}
    {secondaryCtaButton}
    {onlyShowCtaWhenSticky}
    {showCtaOnCtaPage}
    {hiddenUntilScrolled}
    {reverseDesktopCtaButtons}
    {isSticky}
  />
  <MobileNav
    {id}
    {title}
    {navItems}
    {primaryCtaButton}
    {secondaryCtaButton}
    {showCtaOnCtaPage}
    {hiddenUntilScrolled}
    {disableIconCtaOnMobile}
    {isSticky}
  />
</div>
